<template>
  <LandingSection
    class="core-techs"
    title="核心技术"
    desc="凭借自研的 3D 数字人引擎与多模态 AI 视频生成技术，有言让视频创作像写文字一样轻松"
  >
    <div class="core-techs-grid">
      <CoreTechCard v-for="card in list" v-bind="card" />
    </div>
  </LandingSection>
</template>

<script setup lang="ts">
import { getFeUrl } from '@/utils/url';
import CoreTechCard from '~/design/components/core-tech-card/index.vue';
import LandingSection from '~/design/widgets/landing-section/cn-template.vue';

const list = [
  {
    title: '3D 角色引擎',
    desc: '内置数千款超写实 3D 数字人角色，覆盖不同年龄、族裔与风格；支持个性化形象编辑与 3D 数字人形象克隆，快速生成专属 3D 形象。',
    videoSrc: getFeUrl('/youyan-platform/api-intro/core-techs/core-tech-1.mp4'),
    posterSrc: getFeUrl(
      '/youyan-platform/api-intro/core-techs/core-tech-1.png?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '语音生成',
    desc: '基于自研语音大模型，支持高保真语音合成(TTS)和声音克隆(VC)；提供多语言、多音色输出，满足多场景、多角色应用需求。',
    videoSrc: getFeUrl('/youyan-platform/api-intro/core-techs/core-tech-2.mp4'),
    posterSrc: getFeUrl(
      '/youyan-platform/api-intro/core-techs/core-tech-2.png?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '文生 3D 多模态',
    desc: '通过自研文生 3D 多模态大模型，基于文本生成数字人的 3D 动作、表情、手势与 3D 运镜；多模态统一驱动，实现语音、表情与动作的自然同步与情感协调。',
    videoSrc: getFeUrl('/youyan-platform/api-intro/core-techs/core-tech-3.mp4'),
    posterSrc: getFeUrl(
      '/youyan-platform/api-intro/core-techs/core-tech-3.png?x-oss-process=image/format,webp',
    ),
  },
  {
    title: '实时渲染和解算',
    desc: '支持高质量实时渲染，展现自然光影与细腻质感；支持高精度头发与服装物理解算，实现逼真的动态表现。',
    videoSrc: getFeUrl('/youyan-platform/api-intro/core-techs/core-tech-4.mp4'),
    posterSrc: getFeUrl(
      '/youyan-platform/api-intro/core-techs/core-tech-4.png?x-oss-process=image/format,webp',
    ),
  },
];
</script>

<style lang="scss" scoped>
.core-techs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}
</style>
